import { UEListData } from "@/app/interface/homepage";
import React from "react";

interface ProfitAndLoss {
  filteredData: UEListData
}

type ProfitAndLossItem ={
  
    title: string;
    values: string[];
}; // Profit and loss data

const ProfitAndLoss: React.FC<ProfitAndLoss> = ({ filteredData }) => {
 console.log("filteredData11",filteredData.profitAndLossTable)
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left border-collapse">
        <thead>
          <tr className="heading-row">
            <th className="pr-4 py-2 font-medium text-xs text-gray-500 border-b-2 border-black">
              (In Rs. Crore)
            </th>
            {filteredData?.profitAndLossTable?.fiscalYears?.map(
              (item: string, index: number) => (
                <th key={index} className="px-4 py-3 font-medium text-xs text-gray-500 border-b-2 border-black">
                  {item}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {filteredData?.profitAndLossTable?.data?.map(
            (item:ProfitAndLossItem , index: number) => (
              <tr key={index}>
                <td className="pr-4 py-3 font-medium text-sm text-black border-b">
                  {item.title}
                </td>
                {item.values.map((value: string, id: number) => (
                  <td key={id} className="px-4 py-3 font-medium text-sm text-gray-500 border-b">
                    {value}
                  </td>
                ))}
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProfitAndLoss;
